var exports = {
  "kL": "xfd349460--e58d99--container",
  "cL": "xfd349460--e58d99--builder",
  "M3": "xfd349460--e58d99--contacts",
  "h2": "xfd349460--e58d99--logo-link",
  "h_": "xfd349460--e58d99--description",
  "xu": "xfd349460--e58d99--name-link",
  "UU": "xfd349460--e58d99--name",
  "Qs": "xfd349460--e58d99--label--overlap",
  "WD": "xfd349460--e58d99--labels",
  "Qi": "xfd349460--e58d99--builder-name-section",
  "M1": "xfd349460--e58d99--stats",
};

module.exports = exports;
